import { render, staticRenderFns } from "./RessourcesPage.vue?vue&type=template&id=f7287862&scoped=true"
import script from "./RessourcesPage.vue?vue&type=script&lang=js"
export * from "./RessourcesPage.vue?vue&type=script&lang=js"
import style0 from "./RessourcesPage.vue?vue&type=style&index=0&id=f7287862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7287862",
  null
  
)

export default component.exports